module.exports = __webpack_public_path__ + "static/media/public_customer_icon.fe7c18c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/public_customer_icon.png
// module id = 550
// module chunks = 0